import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
const completedCourses = [{
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  creditType: '3 hrs. Comm. Standards',
  dateCompleted: '02/12/2025'
}];
export function ClassHistory() {
  return <div className="space-y-4" data-id="element-1979" data-mp="f6vurwierga0">
      {/* Inserted a styled header section with background color, heading, and description */}
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1980" data-mp="3nngwcs8pn733">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-1981" data-mp="17cnt71c2aza">
          Class History
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-1982" data-mp="3sm0hiqfhceue">
          View your completed courses and download certificates to save or
          print.
        </p>
      </div>

      {/* Salesperson requirements / elective info box */}
      <div className="rounded-lg border border-blue-200 bg-blue-50 p-4" data-id="element-1983" data-mp="2zy4rg4kf1l6l">
        <h2 className="text-sm font-bold text-blue-900 mb-2" data-id="element-1984" data-mp="3edl3clvoni7t">
          Salesperson CE Requirements
        </h2>
        <p className="text-xs text-blue-900/90 leading-relaxed mb-2" data-id="element-1985" data-mp="3jc4quqpxd22a">
          Your 24 hour requirement (every two years) includes 21 hours (7 class
          types), with at least one class (3 hrs) of each of the following credit
          types:
        </p>
        <ul className="text-xs text-blue-900/90 leading-relaxed space-y-0.5 mb-2" data-id="element-1986" data-mp="3t4k81ltedmm4">
          <li data-id="element-1987" data-mp="2vga8ddh33ay6">• Agency Law</li>
          <li data-id="element-1988" data-mp="30dsgx2r6vo5n">• Contract Law</li>
          <li data-id="element-1989" data-mp="30d0lpt1i7sfw">• Disclosure</li>
          <li data-id="element-1990" data-mp="30ebxog53s6i3">• Fair Housing</li>
          <li data-id="element-1991" data-mp="35cwoxq2dnfue">
            • General / Deed Fraud, Firewise &amp; Arizona Water &mdash;{' '}
            <strong data-id="element-1992" data-mp="35f9eopedmui0">Required as of 2025</strong>
          </li>
          <li data-id="element-1993" data-mp="39f9x0l4ljpuc">• Legal Issues</li>
          <li data-id="element-1994" data-mp="39c5iouxf3dpy">
            • Requirements for Licensees (formerly Commissioner's
            Standards/Rules)
          </li>
        </ul>
        <p className="text-xs text-blue-900/90 leading-relaxed" data-id="element-1995" data-mp="onhsjp6nkcxg">
          <strong data-id="element-1996" data-mp="oq40hpxggug7">Elective:</strong> 1 class (3 hours) &mdash; you may choose
          any credit type, providing you do not duplicate any course you have
          already taken within that renewal period.
        </p>
      </div>

      <div data-id="element-1997" data-mp="2uq3jt5mc2cvj">
        <button className="text-blue-600 hover:underline text-sm font-medium uppercase tracking-wide" data-id="element-1998" data-mp="2uoir7ljkx40b">
          CE CREDITS TRACKER
        </button>
        <span className="ml-1 inline-flex items-center justify-center w-4 h-4 rounded-full bg-blue-500 text-white text-xs font-bold" data-id="element-1999" data-mp="2poo1vmfgcmhd">
          ?
        </span>
      </div>

      <p className="text-xs text-slate-600" data-id="element-2000" data-mp="1y0w0m496sfus">
        *You will need Adobe Reader installed on your computer to print the
        certificate.{' '}
        <button className="text-blue-600 hover:underline" data-id="element-2001" data-mp="27099auphl0eg">Click here</button> to
        download the free reader.*
      </p>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-2002" data-mp="1j9daveqiz6y8">
        <div className="overflow-x-auto" data-id="element-2003" data-mp="1ebliykpvrku1">
          <table className="w-full text-sm text-left" data-id="element-2004" data-mp="1eak5k9le6m95">
            <thead style={{
            backgroundColor: '#4A2D8F'
          }} className="text-white font-medium" data-id="element-2005" data-mp="3pyxevpidnmxk">
              <tr data-id="element-2006" data-mp="3uri6qlhq3pyg">
                <th className="px-3 py-2 border-r border-purple-700" data-id="element-2007" data-mp="3gxzc1ajodlgk">Class</th>
                <th className="px-3 py-2 border-r border-purple-700 w-44" data-id="element-2008" data-mp="3gvwbvxot6by4">
                  Credit Type
                </th>
                <th className="px-3 py-2 border-r border-purple-700 w-28 text-center" data-id="element-2009" data-mp="dhjsr4dr64sw">
                  Date Completed
                </th>
                <th className="px-3 py-2 border-r border-purple-700 w-28 text-center" data-id="element-2010" data-mp="hhkk1plyaahd">
                  Print Certificate
                </th>
                <th className="px-3 py-2 w-28 text-center" data-id="element-2011" data-mp="3lgvocxrcwct">Review Class</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-2012" data-mp="2o9lc2p910f2d">
              {completedCourses.map((course, i) => <tr key={i} className="hover:bg-purple-50/20" data-id="element-2013" data-mp="2t8xyx9zwdm4y" data-mpi={i}>
                  <td className="px-3 py-1.5 border-r border-slate-200 text-slate-800 leading-snug" data-id="element-2014" data-mp="2t61zfh8eipee">
                    {course.name}
                  </td>
                  <td className="px-3 py-1.5 border-r border-slate-200 text-slate-700 whitespace-nowrap" data-id="element-2015" data-mp="33qjkvgcbio3k">
                    {course.creditType}
                  </td>
                  <td className="px-3 py-1.5 border-r border-slate-200 text-center text-slate-700 whitespace-nowrap" data-id="element-2016" data-mp="2ur6mpjtn9ly5">
                    {course.dateCompleted}
                  </td>
                  <td className="px-3 py-1.5 border-r border-slate-200 text-center" data-id="element-2017" data-mp="3nfc5i11510vc">
                    <button className="text-blue-600 hover:underline text-sm whitespace-nowrap" data-id="element-2018" data-mp="3ndhlqq1lresu">
                      Print Certificate
                    </button>
                  </td>
                  <td className="px-3 py-1.5 text-center" data-id="element-2019" data-mp="3dj8vk901nxxu">
                    <Link to={`/student/class/${course.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}/content`} className="text-blue-600 hover:underline text-sm whitespace-nowrap" data-id="element-2020" data-mp="2723trftk86oc">
                      Review Class
                    </Link>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}